module.exports = __webpack_public_path__ + "static/media/ipad-7.691fe7f3.jpg";